import { endPoint } from "constants/server/api";
import { createFetchMaster } from "../../utils/fetchFactory";
import { createSlicePrototype } from "../../utils/sliceFactory";
var getAllMstNewItemSoColSlice = createSlicePrototype({
    name: "getAllMstNewItemSoCol"
});
export var getAllMstNewSoItemCol = createFetchMaster({
    actions: getAllMstNewItemSoColSlice.actions,
    config: {
        method: "get",
        url: endPoint.MST_NEW_ITEM_SO_COL
    }
});
var _getAllMstNewItemSoColSlice_actions = getAllMstNewItemSoColSlice.actions;
export var fetchData = _getAllMstNewItemSoColSlice_actions.fetchData, fetchDataSuccess = _getAllMstNewItemSoColSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllMstNewItemSoColSlice_actions.fetchDataFailure, resetState = _getAllMstNewItemSoColSlice_actions.resetState;
export default getAllMstNewItemSoColSlice.reducer;
